import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.

const initialState = {
  data: [],
  error: null,
  loading: false,
  province: null,
  exportStatus: { loading: false, error: null },
};

//  Define slice and it's reducer functions.
const provinceSlice = createSlice({
  name: "province",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setProvince(state, action) {
      state.province = action.payload;
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    resetState(state) {
      state.data = [];
      state.error = null;
      state.loading = false;
      state.province = null;
      state.exportStatus = { loading: false, error: null };
    },
  },
});

export const provinceAction = provinceSlice.actions;

export default provinceSlice;
